import React from "react";

// Esqueleto gris mientras llegan los datos. `compacto` es para usarlo dentro de una tarjeta,
// sin la franja de título.
function Cargando({ compacto = false }) {
  return (
    <div role="status" aria-label="Cargando" style={{ marginTop: "0.75rem" }}>
      {!compacto && <div className="esqueleto" style={{ height: 62, borderRadius: 14, marginBottom: "1rem" }} />}
      <div className="esqueleto" style={{ height: 14, width: "70%", marginBottom: "0.7rem" }} />
      <div className="esqueleto" style={{ height: 14, marginBottom: "0.7rem" }} />
      <div className="esqueleto" style={{ height: 14, width: "85%" }} />
    </div>
  );
}

export default Cargando;
